import { Amenity } from '@shared/models/amenity.model';
import * as fromActions from '../actions/hotel-amenities.actions';

export interface HotelAmenitiesState {
  results: Array<Amenity>;
}

export const initialState: HotelAmenitiesState = {
  results: [],
};

export function reducer(state = initialState, action: fromActions.HotelAmenitiesActions): HotelAmenitiesState {
  switch (action.type) {
    case fromActions.GET_HOTEL_AMENITIES_SUCCESS: {
      const results = action.payload.amenities;

      return {
        ...state,
        results,
      };
    }
    default:
      return state;
  }
}
